import * as LDClient from 'launchdarkly-js-client-sdk';

/**
 * We'll load the axios HTTP library which allows us to easily issue requests
 * to our Laravel back-end. This library automatically handles sending the
 * CSRF token as a header based on the value of the "XSRF" token cookie.
 */

window.axios = require('axios');

window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

window.axios.interceptors.response.use(
    function (response) {
        return response;
    },
    function (error) {
        let LOGIN_ROUTE = '/account/login';
        if (error.response && error.response.status === 401) {
            if (!window.location.href.includes(LOGIN_ROUTE)){
                window.location.href = LOGIN_ROUTE;
            }
        }
        return Promise.reject(error);
    }
);

window.$ = window.jQuery = require('jquery');

// Initialize Launch Darkly
let clientId = window.launchDarkly.clientId;

let ldOptions = {};

if (window.global.env === 'production') {
    ldOptions = {
        logger: LDClient.basicLogger({ level: 'none' }),
    };
}

window.ldClient = LDClient.initialize(clientId, window.launchDarkly.context, ldOptions);